import { environment } from '@environments/environment';
import { apiEndPoints } from './api-end-points';
export const PopupConstants = {
  jusridict: {
    title: 'Delete Jusridict',
    message: 'Are you sure you want to delete this jusridict?',
  },
  income: {
    title: 'Delete Income',
    message: 'Are you sure you want to delete this income?',
  },
  costSale: {
    title: 'Delete Cost Sale',
    message: 'Are you sure you want to delete this cost sale?',
  },
  expense: {
    title: 'Delete Expense',
    message: 'Are you sure you want to delete this expense?',
  },
  expenseClaim: {
    title: 'Delete Expense Claim',
    message: 'Are you sure you want to delete this expense claim?',
  },
  vehicleExpense: {
    title: 'Delete Vehicle Expense',
    message: 'Are you sure you want to delete this vehicle expense?',
  },
  vehicleKiolmeter: {
    title: 'Delete Vehicle Kilometer',
    message: 'Are you sure you want to delete this kilometer?',
  },
  vehicleSubExpense: {
    title: 'Delete Vehicle Expense',
    message: 'Are you sure you want to delete this expense?',
  },
  vehicleAddition: {
    title: 'Delete Vehicle Addition',
    message: 'Are you sure you want to delete this addition?',
  },
  deleteSlip: {
    title: 'Delete Slip',
    message: 'Are you sure you want to delete this slip?',
    buttonOk: 'Yes',
    buttonCancel: 'No'
  },
  deleteBusiness: {
    title: 'Delete Business',
    message: 'Are you sure you want to delete already added business details?',
    buttonOk: 'Yes',
    buttonCancel: 'No'
  },
  homeOffExp: {
    title: 'Delete Home-Off-Exp',
    message: 'Are you sure you want to delete this home-off-exp?',
  },
  interestLoan: {
    title: 'Delete Interest-Loan',
    message: 'Are you sure you want to delete this interest loan?',
    buttonOk: 'Yes',
    buttonCancel: 'No'
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.privacyPolicyPage}/`,
  },
  termsAndConditions: {
    title: 'Terms and Conditions',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.termsAndConditionsPage}/`,
  },
  provincialInfo: {
    // title: 'Incometax Help',
    title: 'TaxSoft.ai Help',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.provincialInfoPage}/`,
  },
  cai: {
    // title: 'Incometax Help',
    title: 'TaxSoft.ai Help',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.cai}/`,
  },
  homeownersPropertyTax: {
    // title: 'Incometax Help',
    title: 'TaxSoft.ai Help',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.homeownersPropertyTax}/`,
  },
  selfEmploymentTax: {
    // title: 'Incometax Help',
    title: 'TaxSoft.ai Help',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.selfEmploymentTax}/`,
  },
  refundableCredit: {
    // title: 'Incometax Help',
    title: 'TaxSoft.ai Help',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.refundableCredit}/`,
  },
  csa: {
    // title: 'Incometax Help',
    title: 'TaxSoft.ai Help',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.csa}/`,
  },
  autoFillSlip: {
    title: 'Auto Fill Slip',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.available_tax_slip}/`,
  },
  cratermAndCondition: {
    title: ' TERM AND CONDITION',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.auto_fill_using_cra}/`,
  },
  DontHaveCraAccount: {
    title: 'dont have Cra Account',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.dont_have_cra_account}/`,
  },
  SignInProblem: {
    title: ' sign in Problem',
    url: `${environment.apiUrl}${apiEndPoints.pages}${apiEndPoints.craSignProblem}/`,
  },
  deleteItrReturn: {
    title: 'Delete Tax Return',
    message: 'Are you sure you want to delete this tax return?',
    buttonOk: 'Yes',
    buttonCancel: 'No'
  },
  discardPopup: {
    title: 'Discard Process',
    message: 'Are you sure you want to discard this process?',
    secondary: 'Your data will be updated in the my previous returns.',
    buttonOk: 'Yes',
    buttonCancel: 'No'
  },
  deleteMovingProfile: {
    title: 'Delete Moving Profile',
    message: 'Are you sure want to delete this moving profile?',
    buttonOk: 'Yes',
    buttonCancel: 'No'
  }
};
